module.exports = __webpack_public_path__ + "static/media/bg.0e64fe84.svg";